export const FIXED_SCHEDULE_DAYS = [
  { key: 'lunes', label: 'Lunes' },
  { key: 'martes', label: 'Martes' },
  { key: 'miercoles', label: 'Miércoles' },
  { key: 'jueves', label: 'Jueves' },
  { key: 'viernes', label: 'Viernes' },
];

const WEEKEND_SCHEDULE = [
  { day: 'Sábado', status: 'LIBRE', start: '', end: '', activity: 'LIBRE' },
  { day: 'Domingo', status: 'LIBRE', start: '', end: '', activity: 'LIBRE' },
];

function normalizeToken(value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase();
}

export function personSystemAlias(person) {
  if (Object.prototype.hasOwnProperty.call(person?.access_differences || {}, "nickname")) return String(person.nickname ?? "").trim();
  return String(
    person?.nickname
    || person?.apodo
    || person?.alias
    || person?.aliases?.[0]
    || person?.nombre
    || person?.name
    || [person?.first_name, person?.last_name].filter(Boolean).join(' ')
    || ''
  ).trim();
}

export function personIdentityNames(person) {
  return Array.from(new Set([
    personSystemAlias(person),
    person?.nickname,
    person?.apodo,
    person?.alias,
    ...(Array.isArray(person?.aliases) ? person.aliases : []),
    person?.nombre,
    person?.name,
    person?.full_name,
    person?.first_name,
    [person?.first_name, person?.last_name].filter(Boolean).join(' '),
  ].map((value) => String(value || '').trim()).filter(Boolean)));
}

export function personMatchesName(person, name) {
  const wanted = normalizeToken(name);
  return !!wanted && personIdentityNames(person).some((candidate) => normalizeToken(candidate) === wanted);
}

export function emptyWeekdaySchedule() {
  return Object.fromEntries(FIXED_SCHEDULE_DAYS.map(({ key }) => [key, {
    enabled: true,
    start: '09:00',
    end: '17:00',
    activity: 'LOGISTICA',
  }]));
}

export function fixedScheduleToWeekdays(schedule) {
  const normalized = emptyWeekdaySchedule();
  if (!Array.isArray(schedule) || !schedule.length) return normalized;

  FIXED_SCHEDULE_DAYS.forEach(({ key, label }, index) => {
    const item = schedule.find((entry) => normalizeToken(entry?.day) === normalizeToken(label)) || schedule[index];
    if (!item) return;
    const status = normalizeToken(item.status);
    normalized[key] = {
      enabled: status !== 'libre' && status !== 'vacio' && item.enabled !== false,
      start: item.start || '09:00',
      end: item.end || '17:00',
      activity: item.activity || 'LOGISTICA',
    };
  });
  return normalized;
}

export function weekdaysToFixedSchedule(weekdays) {
  return [
    ...FIXED_SCHEDULE_DAYS.map(({ key, label }) => {
      const item = weekdays?.[key] || {};
      if (item.enabled === false) {
        return { day: label, status: 'LIBRE', start: '', end: '', activity: 'LIBRE' };
      }
      return {
        day: label,
        status: 'normal',
        start: item.start || '09:00',
        end: item.end || '17:00',
        activity: String(item.activity || 'LOGISTICA').trim().toUpperCase(),
      };
    }),
    ...WEEKEND_SCHEDULE,
  ];
}

export function fixedScheduleForDate(person, date) {
  if (person?.schedule_type !== 'fixed' || !Array.isArray(person?.fixed_schedule)) return null;
  const dayIndex = new Date(`${date}T12:00:00`).getDay();
  if (dayIndex < 1 || dayIndex > 5) return null;
  const { key } = FIXED_SCHEDULE_DAYS[dayIndex - 1];
  const item = fixedScheduleToWeekdays(person.fixed_schedule)[key];
  if (!item?.enabled) return null;
  return item;
}
